// extracted by mini-css-extract-plugin
export default {"dynamicForm":"P32Ra7qVtZZ7nqRx00w_"};